import axios from "axios";
function getBrowserVersion() {
  const ua = navigator.userAgent;

  if (ua.includes("Edg/")) {
    // Microsoft Edge
    const match = ua.match(/Edg\/(\d+\.\d+)/);
    return match ? `Edge/${match[1]}` : "Edge/Unknown";
  }

  if (ua.includes("Chrome") && !ua.includes("Edg")) {
    // Google Chrome
    const match = ua.match(/Chrome\/(\d+\.\d+)/);
    return match ? `Chrome/${match[1]}` : "Chrome/Unknown";
  }

  if (ua.includes("Firefox")) {
    // Mozilla Firefox
    const match = ua.match(/Firefox\/(\d+\.\d+)/);
    return match ? `Firefox/${match[1]}` : "Firefox/Unknown";
  }

  if (ua.includes("Safari") && !ua.includes("Chrome")) {
    // Apple Safari
    const match = ua.match(/Version\/(\d+\.\d+)/);
    return match ? `Safari/${match[1]}` : "Safari/Unknown";
  }

  // 其他浏览器
  return "Unknown";
}

// 创建 axios 实例
const service = axios.create({
  timeout: 10000,
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "X-System-Version": getBrowserVersion(),
    "X-Client-Version": "1.0.0",
    "X-Client-Type": "h5",
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 这里也可以添加通用的 header，如语言、版本号等
    return config;
  },
  (error) => {
    console.error("请求错误:", error);
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 默认直接返回响应体数据，方便调用方使用
    return response.data;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;
      // 简单的状态码处理，可以按需扩展
      if (status === 401) {
        console.warn("未授权或登录已过期");
        // TODO: 可在这里触发登出逻辑或跳转登录页
      } else if (status >= 500) {
        console.error("服务器错误");
      }
    } else {
      console.error("网络异常或请求被取消");
    }

    return Promise.reject(error);
  },
);
export const get = (url, params) => service.get(url, { params });
export const post = (url, data) => service.post(url, data);
export const put = (url, data) => service.put(url, data);
export const del = (url) => service.delete(url);
export default service;
